<template>
    <div class="d-flex">
        <template v-if="$scope.IS_REGULAR_CUSTOMER">
            <HeaderAdvantages class="flex-child-fixed"/>
            <div class="header-top-feature-links hidden-sales-rep ml-auto flex-child-fixed">
                <a href="/central-de-ajuda/#reamaze#0#/kb/trocas-slash-devolucoes">
                    <span><i class="icon-cr icon-exchange white"></i>Trocas e devoluções</span>
                </a>
                <a href="/central-de-ajuda/">
                    <span><i class="icon-cr icon-question-sign white"></i>Tire suas dúvidas</span>
                </a>
                <a href="/atacado">
                    <span><i class="icon-cr icon-profitability white"></i>Chico Rei para lojistas</span>
                </a>
            </div>
        </template>
        <template v-else-if="$scope.IS_WHOLESALER">

        </template>
        <template v-else-if="$scope.IS_SALES_REP">
            <div class="header-top-feature-links hidden-sm-down flex-child-fixed">
                Bem-vindo de volta!
            </div>
            <SalesRepBuyingFor class="header-top-feature-links ml-auto flex-child-fixed"/>
        </template>
    </div>
</template>

<script>
    import SalesRepBuyingFor from "../sales-rep/SalesRepBuyingFor";
    import HeaderAdvantages from "./HeaderAdvantages";

    export default {
        el: '#header-top-feature-vue',
        name: "HeaderTopFeature",
        components: {HeaderAdvantages, SalesRepBuyingFor}
    }
</script>